<template>
    <div id="top-menu">
        <div id="navbar-logo-container">
            <SVGNavbarLogo/>
        </div>
        <div id="navbar-user-container">
            <div id="user-text-container">
                {{userName}}
            </div>
            <div id="user-svg-container" v-on:click="showProfileModal()">
                <SVGNavbarUser/>
            </div>
        </div>
    </div>
</template>

<script>
    import SVGNavbarLogo from "../SVG/SVGNavbarLogo.vue";
    import SVGNavbarUser from "../SVG/SVGNavbarUser.vue";
    import ModalProfile from "../Modal/ModalProfile";
    import UserProfileAP from "../Modal/AdminPage/UserProfileAP";

    export default {
        name: "TheNavbar",
        components: {
            SVGNavbarUser,
            SVGNavbarLogo
        },
        computed:{
            userName(){
                const name = this.$store.state.profile.userName;
                if(name){
                    return name;
                } else {
                    return 'Гость';
                }
            }
        },
        methods:{
            showProfileModal() {
                console.log(this.$store.getters.APPLICATION_VERSION);
                if (this.$store.getters.APPLICATION_VERSION === 'pro') {
                    this.$modal.show(ModalProfile, {}, {
                        height: 'auto',
                        pivotY: 0.2,
                        width: 415,
                        draggable: true,
                    });
                } else if (this.$store.getters.APPLICATION_VERSION === 'adminPanel') {
                    this.$modal.show(UserProfileAP, {}, {
                        height: 'auto',
                        pivotY: 0.2,
                        width: 415,
                        draggable: true,
                    });
                }
            }
        }
    }
</script>

<style scoped>
    @media screen and (max-height: 800px) {
        #top-menu {
            display: grid;
            grid-template-columns: auto auto;
            width: 100%;
            height: 60px;
            background-color: white;
            border-bottom: 2px solid #F2F2F2;
            z-index: 11;
            position: relative;
        }

        #navbar-logo-container {
            display: block;
            margin: 5px 20px;
        }

        #navbar-user-container {
            display: grid;
            grid-template-columns: auto 30px;
            margin: 5px 20px;
            text-align: right;
        }

        #user-text-container {
            padding: 12px 0;
            color: #BDBDBD;
            user-select: none;
        }

        #user-svg-container {
            padding: 4px 0;
            cursor: pointer;
            color: #BDBDBD;
        }
    }

    @media screen and (min-height: 800px) {
        #top-menu {
            display: grid;
            grid-template-columns: auto auto;
            width: 100%;
            height: 80px;
            background-color: white;
            border-bottom: 2px solid #F2F2F2;
            z-index: 11;
            position: relative;
        }

        #navbar-logo-container {
            display: block;
            margin: 15px 30px;
        }

        #navbar-user-container {
            display: grid;
            grid-template-columns: auto 40px;
            margin: 15px 30px;
            text-align: right;
        }

        #user-text-container {
            padding: 14px 0;
            color: #BDBDBD;
            user-select: none;
        }

        #user-svg-container {
            padding: 7px 0;
            cursor: pointer;
            color: #BDBDBD;
        }
    }

    #user-svg-container:hover {
        color: #A3A3A3;
    }

    #user-svg-container:active {
        color: #BDBDBD;
    }

</style>
